import { Allergy, isSourceTypeTranslatable } from '@/modules/surgicalEvent';
import { useCallback } from 'react';
import { useTranslator } from '@ianesthesie-kit/core';

export const useAllergyFormatter = () => {
  const translate = useTranslator();
  return useCallback(
    (allergy: Allergy) => {
      if (!allergy) {
        return '';
      }

      const separator = '\u00A0\u00b7\u00A0'; //&nbsp;&bull;&nbsp;
      return [
        {
          key: allergy.translationSubstanceCode,
          translatable: isSourceTypeTranslatable(allergy?.sourceType)
        }
      ]
        .concat(
          (allergy.reactions ?? []).map((r) => ({
            key: r.translationCode,
            translatable: isSourceTypeTranslatable(r?.sourceType)
          }))
        )
        .map(({ key, translatable }) => (translatable ? translate(key) : key))
        .join(separator);
    },
    [translate]
  );
};
